const initialState = {}

const regionsFilter = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'REGIONS_FILTER.INIT':
      return {...state, ...payload}
    case 'REGIONS_FILTER.UPDATE':
      return {...state, excluded: payload}
    default:
      return state
  }
}

export default regionsFilter
